


<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<bs-listbox [style]="{'width':'100%', 'border': 'none'}"
           [options]="list ?? []"
           [ngModel]="selectedAddress"
           [emptyMessage]="error ?? ''"
           [emptyFilterMessage]="error ?? ''"
           (ngModelChange)="onSelect($event)"
           optionLabel="description" data-testid="selected-address-listbox"></bs-listbox>



